/**
=========================================================
* Trust Cargo - public website content
=========================================================

* Every word on the public site lives here, in Arabic and English, so the
* copy can be changed without going near the layout.
*
*  >>> THINGS YOU MUST REPLACE BEFORE GOING LIVE <<<
* The COMPANY block below holds placeholder contact details. Put the real
* phone, WhatsApp, email and address in and everything on the page - the
* header button, the contact cards, the footer and the WhatsApp link - picks
* them up at once.
*
*/

/* ------------------------------------------------------------------ */
/* REPLACE THESE                                                       */
/* ------------------------------------------------------------------ */

export const COMPANY = {
  // international format, no spaces - used for tel: and wa.me links
  phone: "+970000000000",
  phoneDisplay: "+970 00 000 0000",
  whatsapp: "970000000000",
  email: "info@trust-cargo.co",
  addressAr: "فلسطين - الخليل",
  addressEn: "Hebron, Palestine",
  hoursAr: "السبت - الخميس، 9:00 صباحاً - 6:00 مساءً",
  hoursEn: "Saturday - Thursday, 9:00 - 18:00",
  facebook: "https://facebook.com/",
  instagram: "https://instagram.com/",
};

/* ------------------------------------------------------------------ */
/* COPY                                                                */
/* ------------------------------------------------------------------ */

const ar = {
  dir: "rtl",
  brand: "ترست كارجو",
  brandSub: "الشحن والتخليص الجمركي",

  nav: {
    home: "الرئيسية",
    services: "خدماتنا",
    process: "كيف نعمل",
    news: "أخبار وعروض",
    contact: "تواصل معنا",
    login: "تسجيل الدخول",
    account: "لوحة التحكم",
  },

  // the hero slider - three slides, each with its own accent
  slides: [
    {
      kicker: "من الصين إلى باب مستودعك",
      title: "شحن بحري وجوي بثقة تستحقها",
      text: "نتابع شحنتك من لحظة الشراء من المورّد في الصين حتى تسليمها إليك، بحاويات كاملة أو مشتركة، وبأسعار واضحة بلا مفاجآت.",
      cta: "تتبّع شحنتك",
      cta2: "اطلب عرض سعر",
    },
    {
      kicker: "تخليص جمركي متكامل",
      title: "نُنهي إجراءاتك الجمركية بسرعة ودقّة",
      text: "بيان جمركي، قوائم تعبئة، فواتير، وشهادات المنشأ. فريقنا يعرف الإجراءات عن ظهر قلب فلا تتأخر بضاعتك يوماً واحداً.",
      cta: "تحدّث مع مختص",
      cta2: "خدماتنا",
    },
    {
      kicker: "مستودعنا في الصين",
      title: "نجمع مشترياتك من عشرة موردين في شحنة واحدة",
      text: "اشترِ من حيث شئت، وسنستلم ونفحص ونجمّع كل الطرود في مستودعنا بالصين، ثم نشحنها لك دفعة واحدة وتوفّر على نفسك الكثير.",
      cta: "كيف نعمل",
      cta2: "تواصل معنا",
    },
  ],

  statsTitle: "أرقام من واقع عملنا",
  statsNote: "محدّثة مباشرة من نظامنا",
  stats: {
    containers: "حاوية تم التعامل معها",
    clients: "عميل يثق بنا",
    services: "خدمة لوجستية متكاملة",
    support: "متابعة ودعم",
  },

  servicesTitle: "خدماتنا",
  servicesLead: "كل ما تحتاجه بين مصنع المورّد ومستودعك، تحت سقف واحد.",
  services: [
    {
      icon: "directions_boat",
      title: "الشحن البحري",
      text: "حاويات كاملة (FCL) أو شحن مشترك (LCL) من موانئ الصين الرئيسية، بجدول إبحار منتظم ومتابعة أسبوعية.",
    },
    {
      icon: "gavel",
      title: "التخليص الجمركي",
      text: "إعداد البيان الجمركي وكل المستندات المطلوبة، ومتابعة الفحص والإفراج حتى خروج البضاعة.",
    },
    {
      icon: "warehouse",
      title: "مستودع في الصين",
      text: "نستلم بضاعتك من الموردين، نفحصها ونصوّرها ونجمّعها، ثم نشحنها في حاوية واحدة.",
    },
    {
      icon: "shopping_cart",
      title: "الشراء والتوريد",
      text: "نتعامل مع مورديك بالصينية، نتابع الدفعات والفواتير، ونحرص أن يصل الطلب كما اتفقتم عليه.",
    },
    {
      icon: "local_shipping",
      title: "التوصيل حتى الباب",
      text: "من الميناء إلى مستودعك أو محلك مباشرة، مع تنسيق كامل لموعد التسليم.",
    },
    {
      icon: "fact_check",
      title: "الاستيراد والتصدير",
      text: "استشارة في الأكواد الجمركية والرسوم والمواصفات، لتعرف تكلفتك الحقيقية قبل أن تشتري.",
    },
  ],

  whyTitle: "لماذا ترست كارجو",
  why: [
    {
      icon: "visibility",
      title: "شفافية كاملة",
      text: "تعرف في أي لحظة أين وصلت شحنتك وكم دفعت وكم بقي عليك، من حسابك في النظام.",
    },
    {
      icon: "savings",
      title: "تكلفة أوضح",
      text: "سعر لكل متر مكعب متفق عليه مسبقاً، وكشف حساب مفصّل لكل حاوية.",
    },
    {
      icon: "schedule",
      title: "التزام بالمواعيد",
      text: "جدول إبحار معلن، وإشعار بأي تغيير قبل حدوثه لا بعده.",
    },
    {
      icon: "support_agent",
      title: "شخص واحد مسؤول",
      text: "لك مسؤول ملف واحد يعرف شحنتك، فلا تُعيد شرح قصتك في كل اتصال.",
    },
  ],

  processTitle: "كيف نعمل",
  processLead: "ست خطوات واضحة، وأنت تتابعها خطوة بخطوة.",
  process: [
    { title: "الطلب", text: "تخبرنا بما تريد استيراده، فنرسل لك عرض سعر مفصّلاً." },
    { title: "الشراء", text: "نتواصل مع المورّد، نؤكد المواصفات وندفع الدفعة المتفق عليها." },
    { title: "المستودع", text: "تصل البضاعة إلى مستودعنا في الصين، نفحصها ونجمّعها." },
    { title: "الشحن", text: "تُحمّل في الحاوية وتبحر، ونزوّدك برقم الحاوية وتاريخ الوصول." },
    { title: "التخليص", text: "نُنهي البيان الجمركي والفحص والإفراج عند الوصول." },
    { title: "التسليم", text: "نوصلها إلى بابك، ونغلق الملف بكشف حساب نهائي." },
  ],

  newsTitle: "أخبار وعروض",
  newsLead: "آخر إعلاناتنا ومواعيد الحاويات القادمة.",
  newsEmpty: "لا توجد إعلانات منشورة حالياً.",

  ctaTitle: "جاهز تبدأ شحنتك القادمة؟",
  ctaText: "أرسل لنا تفاصيل بضاعتك وسنعود إليك بعرض سعر خلال يوم عمل واحد.",
  ctaButton: "راسلنا على واتساب",

  contactTitle: "تواصل معنا",
  contactLead: "نجيب على كل استفسار، ولو كان أول استيراد لك.",
  contact: {
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    address: "العنوان",
    hours: "أوقات العمل",
    name: "الاسم",
    message: "رسالتك",
    send: "إرسال عبر واتساب",
    hint: "سيفتح واتساب برسالتك جاهزة للإرسال.",
  },

  footerAbout:
    "ترست كارجو شركة شحن وتخليص جمركي، نستورد لعملائنا من الصين ونتابع بضاعتهم من المورّد حتى باب المستودع.",
  footerLinks: "روابط سريعة",
  footerContact: "معلومات التواصل",
  rights: "جميع الحقوق محفوظة",
  loginNote: "دخول العملاء لمتابعة الشحنات والحسابات",
};

const en = {
  dir: "ltr",
  brand: "Trust Cargo",
  brandSub: "Freight & Customs Clearance",

  nav: {
    home: "Home",
    services: "Services",
    process: "How we work",
    news: "News & Offers",
    contact: "Contact",
    login: "Login",
    account: "Dashboard",
  },

  slides: [
    {
      kicker: "From China to your warehouse door",
      title: "Sea and air freight you can actually rely on",
      text: "We follow your goods from the moment you buy them in China until they reach you - full or shared containers, at a price agreed up front with no surprises.",
      cta: "Track your shipment",
      cta2: "Request a quote",
    },
    {
      kicker: "Complete customs clearance",
      title: "Your paperwork finished quickly and correctly",
      text: "Customs declarations, packing lists, invoices and certificates of origin. Our team knows the procedure by heart, so your goods do not sit waiting a single day.",
      cta: "Talk to a specialist",
      cta2: "Our services",
    },
    {
      kicker: "Our warehouse in China",
      title: "Ten suppliers, one consolidated shipment",
      text: "Buy from whoever you like. We receive, check and consolidate every parcel at our China warehouse, then ship it all together and save you a great deal.",
      cta: "How we work",
      cta2: "Contact us",
    },
  ],

  statsTitle: "Our work in numbers",
  statsNote: "Live from our own system",
  stats: {
    containers: "Containers handled",
    clients: "Clients who trust us",
    services: "Integrated logistics services",
    support: "Follow-up and support",
  },

  servicesTitle: "Our services",
  servicesLead: "Everything between your supplier's factory and your warehouse, under one roof.",
  services: [
    {
      icon: "directions_boat",
      title: "Sea freight",
      text: "Full containers (FCL) or shared loads (LCL) from the main Chinese ports, on a regular sailing schedule with weekly updates.",
    },
    {
      icon: "gavel",
      title: "Customs clearance",
      text: "We prepare the declaration and every required document, then follow inspection and release until the goods are out.",
    },
    {
      icon: "warehouse",
      title: "China warehouse",
      text: "We receive your goods from suppliers, inspect and photograph them, consolidate, and ship in a single container.",
    },
    {
      icon: "shopping_cart",
      title: "Sourcing & purchasing",
      text: "We deal with your suppliers in Chinese, track payments and invoices, and make sure the order arrives as agreed.",
    },
    {
      icon: "local_shipping",
      title: "Door-to-door delivery",
      text: "From the port straight to your warehouse or shop, with the delivery time fully coordinated.",
    },
    {
      icon: "fact_check",
      title: "Import & export advice",
      text: "Guidance on HS codes, duties and specifications, so you know your real landed cost before you buy.",
    },
  ],

  whyTitle: "Why Trust Cargo",
  why: [
    {
      icon: "visibility",
      title: "Full transparency",
      text: "See where your shipment is, what you have paid and what is still due - any time, from your own account.",
    },
    {
      icon: "savings",
      title: "Clearer costs",
      text: "A CBM price agreed in advance, and an itemised statement for every container.",
    },
    {
      icon: "schedule",
      title: "We keep to dates",
      text: "A published sailing schedule, and notice of any change before it happens rather than after.",
    },
    {
      icon: "support_agent",
      title: "One person responsible",
      text: "A single file handler who knows your shipment, so you never explain your story twice.",
    },
  ],

  processTitle: "How we work",
  processLead: "Six clear steps, and you follow every one of them.",
  process: [
    { title: "Enquiry", text: "Tell us what you want to import and we send a detailed quotation." },
    {
      title: "Purchase",
      text: "We contact the supplier, confirm specs and pay the agreed deposit.",
    },
    {
      title: "Warehouse",
      text: "Goods arrive at our China warehouse, where we check and consolidate.",
    },
    {
      title: "Shipping",
      text: "Loaded into the container and sailing, with the container number and ETA.",
    },
    { title: "Clearance", text: "We complete the declaration, inspection and release on arrival." },
    {
      title: "Delivery",
      text: "Delivered to your door, and the file closed with a final statement.",
    },
  ],

  newsTitle: "News & offers",
  newsLead: "Our latest announcements and upcoming container dates.",
  newsEmpty: "No announcements published at the moment.",

  ctaTitle: "Ready to start your next shipment?",
  ctaText:
    "Send us the details of your goods and we will come back with a quote within one working day.",
  ctaButton: "Message us on WhatsApp",

  contactTitle: "Contact us",
  contactLead: "We answer every question, even if this is your first time importing.",
  contact: {
    phone: "Phone",
    email: "Email",
    address: "Address",
    hours: "Working hours",
    name: "Your name",
    message: "Your message",
    send: "Send via WhatsApp",
    hint: "This opens WhatsApp with your message ready to send.",
  },

  footerAbout:
    "Trust Cargo is a freight and customs clearance company. We import for our clients from China and follow their goods from the supplier to the warehouse door.",
  footerLinks: "Quick links",
  footerContact: "Get in touch",
  rights: "All rights reserved",
  loginNote: "Client login - track shipments and accounts",
};

const content = { ar, en };

export default content;
